<template>
  <div class="color-swatches" role="radiogroup" :aria-label="label">
    <button
      v-for="c in presets"
      :key="c"
      type="button"
      role="radio"
      class="color-swatches__item"
      :class="{ 'color-swatches__item--active': isSame(c) }"
      :style="{ background: c }"
      :aria-checked="isSame(c) ? 'true' : 'false'"
      :aria-label="c"
      @click="$emit('input', c)"
    />
    <label
      class="color-swatches__item color-swatches__item--custom"
      :class="{ 'color-swatches__item--active': isCustom }"
      :style="isCustom ? { background: value } : null"
      :title="customLabel"
    >
      <input
        type="color"
        :value="value"
        :aria-label="customLabel"
        @input="$emit('input', $event.target.value)"
      >
      <span v-if="!isCustom" aria-hidden="true">+</span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'ColorSwatches',

  props: {
    value: { type: String, default: '#000000' },
    presets: { type: Array, required: true },
    label: { type: String, default: '' },
    customLabel: { type: String, default: '' },
  },

  computed: {
    isCustom() {
      return !this.presets.some(c => this.isSame(c))
    },
  },

  methods: {
    isSame(c) {
      return String(this.value).toLowerCase() === c.toLowerCase()
    },
  },
}
</script>

<style scoped>
.color-swatches {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.color-swatches__item {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 2px solid #fff;
  border-radius: 50%;
  box-shadow: 0 0 0 1px #d8d6de;
  cursor: pointer;
  transition: transform 0.12s, box-shadow 0.12s;
}

.color-swatches__item:hover {
  transform: scale(1.1);
}

.color-swatches__item:focus-visible,
.color-swatches__item--active {
  box-shadow: 0 0 0 2px #5e5873;
}

.color-swatches__item--custom {
  background: conic-gradient(#ea5455, #ff9f43, #ffd43b, #28c76f, #00a1e0, #7367f0, #e83e8c, #ea5455);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  line-height: 1;
  text-shadow: 0 0 3px rgba(0, 0, 0, 0.6);
}

.color-swatches__item--custom input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
</style>
